import React from 'react';

const ability = ( props: React.SVGProps<SVGSVGElement> ) => {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.3456 3.21545C21.4987 3.30419 21.6172 3.44222 21.6816 3.60699C21.7461 3.77176 21.7528 3.95353 21.7007 4.1226L18.8838 13.2755H24.0812C24.2339 13.2754 24.3833 13.3201 24.511 13.404C24.6386 13.4879 24.7389 13.6073 24.7994 13.7475C24.86 13.8877 24.8782 14.0426 24.8517 14.1931C24.8252 14.3435 24.7553 14.4829 24.6505 14.594L12.138 27.8885C12.0169 28.0173 11.8558 28.1012 11.6809 28.1267C11.506 28.1521 11.3277 28.1176 11.175 28.0287C11.0222 27.9398 10.9041 27.8018 10.8398 27.6372C10.7755 27.4726 10.7689 27.291 10.821 27.1221L13.6379 17.9677H8.44055C8.28781 17.9677 8.13839 17.9231 8.01075 17.8392C7.88311 17.7553 7.78282 17.6359 7.72227 17.4957C7.66173 17.3554 7.64357 17.2006 7.67004 17.0501C7.69651 16.8997 7.76645 16.7603 7.87123 16.6492L20.3837 3.35465C20.5046 3.22608 20.6655 3.1422 20.8401 3.11664C21.0148 3.09108 21.1929 3.12536 21.3456 3.21388V3.21545Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ability;
